import { Service, service, inject } from './di'
import { ConfigService } from './ConfigService'
import { LocationService } from './LocationService'
import { ReleaseService } from './ReleaseService'

@service('BlackFridayService')
export class BlackFridayService extends Service {
    @inject config: ConfigService
    @inject location: LocationService
    @inject releaseService: ReleaseService

    isEnabled() {
        return this.releaseService.shouldUseBlackfridayDesign
    }

    isOnHost() {
        return (
            location.href.includes('/black-friday') ||
            location.href.includes('/vendredi-fou')
        )
    }

    getHostLink() {
        const path =
            this.location.locale === 'fr-ca'
                ? 'circulaires'
                : this.location.locale === 'en-us'
                  ? 'weekly_ads'
                  : 'flyers'
        // const category = 'cyber-week'
        const category = this.config.BF_CATEGORY
        return `${this.location.locale}/${path}/${category}?postal_code=${this.location.postalCode}`
    }

    redirectToHost() {
        window.location.href = this.getHostLink()
    }
}
